import React from 'react';
import TimePicker from 'react-bootstrap-time-picker';
import {Control} from 'react-redux-form';

const TimeSelector = ({model, modelValue, controlProps = {}, mapProps = {}, ...props}) => {
  // we have two different timepickers currently in use -- see TimePicker.jsx for the other one
  // This one allows for choosing numbers from a dropdown and passes an integer in seconds to the controller
  return <Control.text
    {...props}
    model={model}
    component={TimePicker}
    controlProps={{
      start: "00:00",
      end: "23:59",
      step: 60,
      initialValue: modelValue,
      ...controlProps
    }}
    {...mapProps}
  />
};

export default TimeSelector;
